import React, { useEffect, useState } from 'react';
import api from '../api';

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/admin/dashboard').then(setData).catch((e) => setError(e.message));
  }, []);

  if (error) return <Header title="Dashboard" sub={error} />;
  if (!data) return <Header title="Dashboard" sub="Loading…" />;

  const s = data.stats;
  const cards = [
    { label: 'Total Users', value: s.totalUsers, icon: '👥', color: 'var(--secondary)' },
    { label: 'Active (24h)', value: s.activeUsers, icon: '🟢', color: 'var(--like)' },
    { label: 'New This Week', value: s.newUsersThisWeek, icon: '✨', color: 'var(--accent)' },
    { label: 'Verified', value: s.verifiedUsers, icon: '✔️', color: 'var(--secondary)' },
    { label: 'Total Matches', value: s.totalMatches, icon: '💞', color: 'var(--primary)' },
    { label: 'Total Swipes', value: s.totalSwipes, icon: '👆', color: 'var(--text-dim)' },
    { label: 'Premium Members', value: s.premiumUsers, icon: '👑', color: 'var(--accent)' },
    { label: 'Revenue', value: `₹${s.revenueInr.toLocaleString('en-IN')}`, icon: '💰', color: 'var(--like)' },
  ];

  const maxTrend = Math.max(1, ...data.signupTrend.map((t) => t.count));

  return (
    <div>
      <Header title="Dashboard" sub="Platform overview & analytics" />
      <div style={styles.grid}>
        {cards.map((c) => (
          <div key={c.label} className="card" style={styles.statCard}>
            <div style={{ ...styles.statIcon, background: `${c.color}22` }}>{c.icon}</div>
            <div>
              <div style={styles.statValue}>{c.value}</div>
              <div style={styles.statLabel}>{c.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="card" style={{ marginTop: 24 }}>
        <h3 style={{ marginTop: 0 }}>New signups (last 7 days)</h3>
        <div style={styles.chart}>
          {data.signupTrend.length === 0 ? (
            <p style={{ color: 'var(--text-muted)' }}>No signups in this period.</p>
          ) : (
            data.signupTrend.map((t) => (
              <div key={t._id} style={styles.bar}>
                <div style={{ ...styles.barFill, height: `${(t.count / maxTrend) * 140 + 6}px` }}>
                  <span style={styles.barValue}>{t.count}</span>
                </div>
                <span style={styles.barLabel}>{t._id.slice(5)}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export function Header({ title, sub }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <h1 style={{ margin: 0, fontSize: 28 }}>{title}</h1>
      {sub ? <p style={{ color: 'var(--text-dim)', margin: '6px 0 0' }}>{sub}</p> : null}
    </div>
  );
}

const styles = {
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16 },
  statCard: { display: 'flex', alignItems: 'center', gap: 16 },
  statIcon: { width: 50, height: 50, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 },
  statValue: { fontSize: 26, fontWeight: 800 },
  statLabel: { color: 'var(--text-dim)', fontSize: 13, marginTop: 2 },
  chart: { display: 'flex', alignItems: 'flex-end', gap: 18, height: 190, paddingTop: 20 },
  bar: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 },
  barFill: { width: 38, background: 'linear-gradient(180deg, var(--primary), var(--secondary))', borderRadius: 8, display: 'flex', justifyContent: 'center', alignItems: 'flex-start', paddingTop: 4, minWidth: 38 },
  barValue: { fontSize: 12, fontWeight: 800, color: '#fff' },
  barLabel: { fontSize: 11, color: 'var(--text-muted)' },
};
